import { AppTheme } from "App.theme";
import { Buttons } from "features/Runs/components/Forms/MethodDetails/Button";
import { Formik, FormikErrors, FormikHelpers } from "formik";
import {
  PlateMetadataInput,
  RunTaskInput,
} from "graphql/generated/schema-types";
import * as _ from "lodash";
import React from "react";
import styled from "styled-components";

const ErrorEntryTitle = styled.h6`
  color: ${({ theme }) => theme.palette.secondary.light};
`;
const ErrorEntry = styled.li`
  color: ${({ theme }) => theme.palette.secondary.light};
`;
export function CeligoScanForm({
  handleSubmit,
  initialValue,
  isReserved,
  hasActivePlates,
}: {
  handleSubmit: (
    values: RunTaskInput,
    actions: FormikHelpers<RunTaskInput>
  ) => void;
  initialValue: RunTaskInput;
  isReserved: boolean;
  hasActivePlates: boolean;
}): JSX.Element {
  if (!initialValue) return <React.Fragment />;
  return (
    <Formik onSubmit={handleSubmit} initialValues={initialValue}>
      {({ handleSubmit, errors, touched, isSubmitting }) => {
        let plateErrors: Array<
          { barcode: string } & FormikErrors<PlateMetadataInput>
        > = [];
        if (errors?.methodReservationPlateMetadata)
          plateErrors = JSON.parse(
            errors.methodReservationPlateMetadata as string
          );
        return (
          <form onSubmit={handleSubmit}>
            <Buttons
              alreadyReserved={isReserved}
              hasActivePlates={hasActivePlates}
              isSubmitting={isSubmitting}
            />
            {plateErrors.map((plateError) => (
              <>
                <ErrorEntryTitle>{plateError.barcode}</ErrorEntryTitle>
                <ul>
                  {Object.entries(plateError).map((entry, idx) => {
                    if (entry[0] !== "barcode")
                      return (
                        <ErrorEntry
                          key={idx}
                          color={AppTheme.palette.secondary.light}
                        >
                          {_.startCase(entry[0])}: {entry[1]}
                        </ErrorEntry>
                      );
                  })}
                </ul>
              </>
            ))}
          </form>
        );
      }}
    </Formik>
  );
}
